/* eslint-disable react/no-array-index-key, react/no-this-in-sfc */
import React from 'react';
import { connect } from 'react-redux';
import ManagerItem from '../list-item';
import Loading from '../../common/loading';
import { withNamespaces } from 'react-i18next';

const ManagerList = props => (
  <div className="card">
    <div className="header">
      <h4 className="title">
          {props.t("managers")}
      </h4>
    </div>
    <div className="content">
      <Loading rows={1} loading={props.auth.loading}>
        <ul className="list-unstyled team-members">
          {
                        props.auth.user.managers.length > 0
                          ? props.auth.user.managers.map(
                            (manager, key) => <ManagerItem key={key} manager={manager} />)
                          : (
                            <li>
                              <span style={{ paddingLeft: '10px' }}>
                                  {props.t("anyManagerConnect")}
                              </span>
                            </li>
                          )
                    }
        </ul>
      </Loading>
    </div>
  </div>
);

const mapStateToProps = state => ({
  auth: state.auth
});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ManagerList));



// WEBPACK FOOTER //
// ./src/components/manager/list/index.js